

function TermsConditions() {
    return (
        <div>
            <p><strong>Earn with Neoo Search Business Rewards</strong></p>
            <p>Last Updated: 2026</p>
            <p>These Terms and Conditions (“Terms”) govern the use of the Neoo Search Rewards Program (“Rewards Program”), including earning points, redeeming offers, issuing vouchers, and participating in partner promotions. By using the Rewards Program, you agree to these Terms.</p>
            <hr />
            <div className='textarea'>
                <h4 className='headline mb-2'>1. Definitions</h4>
                <ul>
                    <li className='text ml-5'><p>The Rewards Program is available exclusively to <strong>Neoo Search Premium Members</strong>.</p></li>
                    <li className='text ml-5'><p>Only active Premium accounts may earn and redeem reward points.</p></li>
                    <li className='text ml-5'><p>Non-Premium users are not eligible for reward points, offers, or voucher redemption.</p></li>
                </ul>
                <h4 className='headline mb-2'>2. Earning Reward Points</h4>
                <p>Premium Members earn points through specific activities within the Neoo Search platform, including:</p>
                <ul>
                    <li className='text ml-5'><p>Adding members</p></li>
                    <li className='text ml-5'><p>Sharing NeooCards</p></li>
                    <li className='text ml-5'><p>Posting updates</p></li>
                    <li className='text ml-5'><p>Engaging with profiles</p></li>
                    <li className='text ml-5'><p>Redeeming eligible offers</p></li>
                    <li className='text ml-5'><p>Other activities as defined by Neoo Search</p></li>
                </ul>
                <p>Neoo Search may add, remove, or modify earning rules at any time.</p>
                <p> Certain actions may grant bonus points after a successful redemption.</p>

                <h4 className='headline mb-2'>3. Offer Expiry</h4>
                <p>Offer have an expiry date based on partner-defined validity, such as:</p>
                <ul>
                    <li className='text ml-5'><p>30 days</p></li>
                    <li className='text ml-5'><p>1 month</p></li>
                    <li className='text ml-5'><p>3 months</p></li>
                    <li className='text ml-5'><p>6 months</p></li>
                </ul>
                <p>Offers are automatically removed and cannot be restored or refunded.</p>

                <h4 className='headline mb-2'>4. Redeeming Offers</h4>
                <p>Members may redeem their points for available offers listed in:</p>
                <ul>
                    <li className='text ml-5'><p>The Rewards dashboard</p></li>
                    <li className='text ml-5'><p>The Redeem page</p></li>
                    <li className='text ml-5'><p>Partner listings</p></li>
                </ul>
                <p> Each offer is subject to availability and may be changed or withdrawn at any time.</p>
                <p>Members may redeem only one voucher per partner per day.</p>
                <p>Points used for redemption are non-refundable, even if the voucher is not used.</p>


                <h4 className='headline mb-2'>5. Voucher Issuance & Validity</h4>
                <p>Once a member selects an offer, a digital voucher will be issued and stored in My Wallet.</p>
                <p>Voucher validity is defined by the partner, such as:</p>
                <ul>
                    <li className='text ml-5'><p>24 hours</p></li>
                    <li className='text ml-5'><p>48 hours</p></li>
                    <li className='text ml-5'><p>3 days</p></li>
                </ul>
                <p> After the validity period expires, the voucher becomes invalid automatically.</p>
                <p>Once a voucher is redeemed at the partner’s location, it cannot be reused.</p>


                <h4 className='headline mb-2'>6. Partner Terms & Responsibilities</h4>
                <p>Partner offers are <strong>created and managed by Neoo Search</strong>, but:</p>
                <ul>
                    <li className='text ml-5'><p>Code is automatically generated on voucher</p></li>
                    <li className='text ml-5'><p>Partners define the terms and conditions for each offer</p></li>
                    <li className='text ml-5'><p>Neoo Search collects and displays these details to the user</p></li>
                </ul>
                <p> Neoo Search is not responsible for partner service quality, availability, or any issues arising during redemption.</p>
                <p>Each partner’s terms apply and must be followed by the member.</p>


                <h4 className='headline mb-2'>7. Restrictions</h4>
                <p>Reward points <strong>cannot be transferred</strong> to other users.</p>
                <p>Points cannot be exchanged for cash or any other monetary value.</p>
                <p>Members cannot combine points from multiple accounts.</p>
                <p>Only <strong>one voucher per partner per day</strong> may be redeemed.</p>

                <h4 className='headline mb-2'>8. Fraud and Misuse</h4>
                <p>Neoo Search reserves the right to investigate and take action against fraud or misuse, including:</p>
                <ul>
                    <li className='text ml-5'><p>Fake or misleading profiles</p></li>
                    <li className='text ml-5'><p>Duplicate or multiple accounts</p></li>
                    <li className='text ml-5'><p>Manipulating reward actions</p></li>
                    <li className='text ml-5'><p>Misuse of offers or vouchers</p></li>
                    <li className='text ml-5'><p>Attempted resale of vouchers</p></li>
                    <li className='text ml-5'><p>Any activity violating Neoo Search policies</p></li>
                </ul>
                <p>Actions may include:</p>
                <ul>
                    <li className='text ml-5'><p>Reversal of points</p></li>
                    <li className='text ml-5'><p>Blocking vouchers</p></li>
                    <li className='text ml-5'><p>Suspension of reward privileges</p></li>
                    <li className='text ml-5'><p>Permanent account termination</p></li>
                </ul>

                <h4 className='headline mb-2'>9. Program Changes</h4>
                <p>Neoo Search may update, modify, or discontinue any part of the Rewards Program at any time.</p>
                <p> Any changes will be posted with an updated “Last Updated” date.</p>

                <h4 className='headline mb-2'>10. Geographic Limitations</h4>
                <p>The Rewards Program is currently available <strong>only within the United Arab Emirates (UAE)</strong>.</p>
                <p> Offers and vouchers cannot be redeemed outside the UAE.</p>

                <h4 className='headline mb-2'>11. Support & Contact</h4>
                <p>For questions, complaints, or assistance with rewards, points, or vouchers, contact:</p>
                <p> <strong> support@neoosearch.com</strong></p>
            </div>
        </div>
    );
}

export default TermsConditions;